const Experience = ({ data }) => {
  return (
    <section className="section pt-0" id="experience">
      <div
        className="col-lg-6 wow fadeInUp container text-center mb-5"
        data-wow-delay="0.5s"
        style={{
          visibility: "visible",
          animationDelay: "0.1s",
          animationName: "fadeInUp",
        }}
      >
        <h1 className="mb-4">Experience</h1>
        <div className="p-0">
          <div className="row gy-5 gx-4">
            {data.workExperience.map((work, id) => {
              return (
                <div key={id} className="col-sm-6 ">
                  <img
                    src={
                      work.companyLogo ||
                      "https://www.kindpng.com/picc/m/179-1791617_microsoft-office-save-icon-office-symbol-black-and.png"
                    }
                    style={{ height: "50px" }}
                    alt={work.companyName}
                  />
                  <h4 className="mb-0">{work.companyName}</h4>

                  <p className="mb-1">
                    {work.startDate}-{work.endDate}
                  </p>
                  {work.position}
                  <hr className="my-2"></hr>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
export default Experience;
